import CollectionsTransactions from './CollectionsTransactions.redux';

export default CollectionsTransactions;
